// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.reaction-picker {
  animation: reaction-picker-in 0.15s ease-out;
  transform-origin: top center;
}

/* Les emojis descendent en cascade à l'ouverture */
.reaction-picker-emoji {
  animation: reaction-picker-emoji-in 0.25s ease-out both;
}
@keyframes reaction-picker-emoji-in {
from {
    opacity: 0;
    transform: translateY(-8px);
}
to {
    opacity: 1;
    transform: translateY(0);
}
}
@keyframes reaction-picker-in {
from {
    opacity: 0;
    transform: translateY(-4px) scale(0.95);
}
to {
    opacity: 1;
    transform: translateY(0) scale(1);
}
}
`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
